import React from 'react';
import { Link } from 'react-router-dom';

const LEGAL_DOCS = [
  {
    path: '/support/legal/terms',
    title: '利用規約',
    description: 'サービスの利用条件',
  },
  {
    path: '/support/legal/privacy',
    title: 'プライバシーポリシー',
    description: '個人情報の取扱いについて',
  },
  {
    path: '/support/legal/commerce',
    title: '特定商取引法に基づく表記',
    description: '販売事業者・取引条件の表示',
  },
];

/**
 * ログイン後 Hub 内の規約・ポリシー一覧
 */
export default function HubLegalIndexPage() {
  return (
    <>
      <div className="hub-main-header">
        <h1 className="hub-page-title">規約・ポリシー</h1>
      </div>
      <div className="hub-main-content">
        <div className="hub-card hub-enter-panel" data-panel-index="0">
          <ul className="hub-legal-index-list">
            {LEGAL_DOCS.map((doc) => (
              <li key={doc.path} className="hub-legal-index-item">
                <Link to={doc.path} className="hub-legal-index-link">
                  <span className="hub-legal-index-title">{doc.title}</span>
                  <span className="hub-legal-index-desc">{doc.description}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
